import { __awaiter, __generator, __spreadArray } from 'tslib';
import { Thread, Transfer, expose } from 'threads';

var TerminateController = /** @class */ (function () {
    function TerminateController() {
        this.threads = [];
        this.pools = [];
    }
    TerminateController.prototype.addThread = function (thread) {
        this.threads.push(thread);
    };
    TerminateController.prototype.addPool = function (pool) {
        this.pools.push(pool);
    };
    TerminateController.prototype.terminate = function (force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(__spreadArray(__spreadArray([], this.threads.map(function (t) { return Thread.terminate(t); })), this.pools.map(function (p) { return p.terminate(force); })))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return TerminateController;
}());

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getGlobal() {
    if (typeof globalThis !== 'undefined') {
        return globalThis;
    }
    else if (typeof self !== 'undefined') {
        return self;
    }
    else if (typeof window !== 'undefined') {
        return window;
    }
    else if (typeof global !== 'undefined') {
        return global;
    }
    throw new Error('unable to locate global object');
}
var globalThis$1 = getGlobal();

function instanceOf(obj, className) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var Type = globalThis$1[className];
    return Type != null && obj instanceof Type;
}
function isTransferable(obj) {
    return (instanceOf(obj, 'ArrayBuffer') ||
        instanceOf(obj, 'MessagePort') ||
        instanceOf(obj, 'ImageBitmap') ||
        instanceOf(obj, 'OffscreenCanvas'));
}
function isTypedArray(obj) {
    return (instanceOf(obj, 'Int8Array') ||
        instanceOf(obj, 'Uint8Array') ||
        instanceOf(obj, 'Uint8ClampedArray') ||
        instanceOf(obj, 'Int16Array') ||
        instanceOf(obj, 'Uint16Array') ||
        instanceOf(obj, 'Int32Array') ||
        instanceOf(obj, 'Uint32Array') ||
        instanceOf(obj, 'Float32Array') ||
        instanceOf(obj, 'Float64Array') ||
        instanceOf(obj, 'BigInt64Array') ||
        instanceOf(obj, 'BigUint64Array'));
}
/**
 * A function that will recursively inspect an object and return a Threads
 * `Transfer` that contains all the `Transferable`s in the given object.
 *
 * @param obj The object to make transferable.
 * @returns A `Transfer` from Threads.
 */
function makeTransferable(obj) {
    if (isTransferable(obj)) {
        return Transfer(obj);
    }
    else if (obj != null && typeof obj === 'object') {
        var transferables = findTransferables(obj);
        return Transfer(obj, transferables);
    }
    else {
        return obj;
    }
}
function findTransferables(obj) {
    if (isTransferable(obj)) {
        return [obj];
    }
    else if (typeof obj === 'object') {
        if (Array.isArray(obj)) {
            var result_1 = [];
            obj.forEach(function (o) { return result_1.push.apply(result_1, findTransferables(o)); });
            return result_1;
        }
        else if (isTypedArray(obj)) {
            return [obj.buffer];
        }
        else if (obj != null) {
            return Object.values(obj).reduce(function (acc, value) {
                acc.push.apply(acc, findTransferables(value));
                return acc;
            }, []);
        }
        else {
            return [];
        }
    }
    else {
        return [];
    }
}

/**
 * Defines a web worker implementation. This function wraps the `expose` method
 * of Threads and handles automatic conversion of Transferable types.
 *
 * @param impl The worker implementation.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Transferable
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function defineWorker(impl, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.expose, expose$1 = _c === void 0 ? expose : _c;
    function wrap(f) {
        var _this = this;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(_this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, f.apply(void 0, args)];
                        case 1:
                            res = _a.sent();
                            return [2 /*return*/, makeTransferable(res)];
                    }
                });
            });
        };
    }
    if (typeof impl === 'function') {
        return expose$1(wrap(impl));
    }
    else {
        var mod = Object.entries(impl).reduce(function (mod, _a) {
            var key = _a[0], fn = _a[1];
            mod[key] = wrap(fn);
            return mod;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, {});
        return expose$1(mod);
    }
}

export { TerminateController, defineWorker, makeTransferable };
//# sourceMappingURL=bundle.esm.js.map
